import EventEmitter from '@/services/EventEmitter';
import EventManager from '../../EventManager';

export default class AudioProcessor {
  constructor(audio, options) {
    this.initOptions(options);
    audio.muted = true;
    this.audio = audio;
    this.emitter = new EventEmitter();
    this.eventManager = new EventManager();
    this.bindEvents();
  }

  initOptions(options) {
    this.options = options || {};
    if (!this.options.skipIntervalSec) this.options.skipIntervalSec = 10;
  }

  bindEvents() {
    const { audio } = this;

    const onAudioPlayEvent = this.onAudioPlay.bind(this, audio);
    const onAudioEndedEvent = this.onAudioEnded.bind(this, audio);

    this.eventManager.bindEvent(audio, 'play', onAudioPlayEvent);
    this.eventManager.bindEvent(audio, 'ended', onAudioEndedEvent);
  }

  onAudioPlay(audio) {
    this.emitter.emit('audio:play', audio);
  }

  onAudioEnded(audio) {
    clearTimeout(this.skipTimeout);
    this.emitter.emit('audio:ended', audio);
  }

  play(src) {
    const { audio } = this;

    audio.setAttribute('src', src);
    const playPromise = audio.play();

    if (playPromise !== undefined) {
      playPromise.finally(() => this.setSkipInterval(audio));
    } else {
      this.setSkipInterval(audio);
    }
  }

  setSkipInterval(audio) {
    this.skipTimeout = this.initSkipTimeout(audio);
  }

  initSkipTimeout(audio, lastMediaTime = 0) {
    return setTimeout(() => {
      if (lastMediaTime === audio.currentTime) {
        console.log(`Медиа элемент ${audio.id} не воспроизвелся в течение ${this.options.skipIntervalSec} секунд, переключаем на следующее`);
        this.skipAudio(audio);
      } else {
        this.skipTimeout = this.initSkipTimeout(audio, audio.currentTime);
      }
    }, this.options.skipIntervalSec * 1000);
  }

  skipAudio(audio) {
    this.onAudioEnded(audio);
  }

  destroy() {
    this.eventManager.unsubscribe();
  }
}
